module.exports = __webpack_public_path__ + "media/img/favicon-16x16-f6fb04c9020ae99f9857a38ca66dc545.png";